export const isEmptyObject = (obj) => {
  return obj && typeof obj === "object" && !Array.isArray(obj) && Object.keys(obj).length === 0;
};

export const areAllKeysEmpty = (obj = {}) => {
  return Object.values(obj).every(
    (value) => value === null || value === undefined || (typeof value === "string" && value.trim() === "")
  );
};
export const isNullableValue = (obj) =>
  obj === null ||
  obj === undefined ||
  (typeof obj === "string" && obj === "") ||
  (Array.isArray(obj) && obj.length === 0);

export const returnArray = (data) => {
  if (data && data.length > 0) {
    return data;
  } else {
    return [];
  }
};

export const objectToQueryString = (obj) => {
  const entries = Object.entries(obj);

  const queryString = entries
    .map(([key, value]) => {
      let transformedKey;
      switch (key) {
        case "perPage":
          transformedKey = "per_page";
          break;
        default:
          transformedKey = key;
          break;
      }
      return `${transformedKey}=${value}`;
    })
    .join("&");

  return queryString;
};

export const classNames = (...classes) => {
  return classes.filter(Boolean).join(" ");
};

export const getSubdomain = (url) => {
  const hostname = new URL(url).hostname; // This extracts "staging.primerole.com" from "https://staging.primerole.com/"
  const parts = hostname.split(".");

  if (parts.length === 3) {
    // e.g., ["staging", "primerole", "com"]
    return parts[1]; // Returns "primerole"
  } else if (parts.length === 2) {
    // e.g., ["primerole", "com"]
    return parts[0]; // Returns "primerole"
  }
};

export const badgeMapping = {
  updated: "blue-light",
  created: "gray",
  deleted: "error",
  declined: "error",
  approved: "success",
  requested: "gray",
  accepted: "success",
  withdrawn: "orange",
  pending: "warning",
  expired: "gray",
  default: "gray",
};

export const getVariant = (status) => {
  if (status && status.toLowerCase() && badgeMapping[status.toLowerCase()]) {
    console.log(badgeMapping[status.toLowerCase()]);
    return badgeMapping[status.toLowerCase()];
  } else {
    return badgeMapping.default;
  }
};

export const generateRandomString = () => {
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var length = 40;
  var randomString = "";

  for (var i = 0; i < length; i++) {
    var randomIndex = Math.floor(Math.random() * characters.length);
    randomString += characters.charAt(randomIndex);
  }

  return randomString;
};

export const crmRecordKeyValue = (type, apiName, crmObjectsConfig = []) => {
  try {
    const obj = crmObjectsConfig.find((obj) => obj.type === type && obj.crm_object_api_name === apiName);
    const personFields = [
      { key: "job_title", label: "Job Title", crm_field_api_name: "" },
      {
        key: "company",
        label: "Company name",
        crm_field_api_name: "",
      },
      { key: "city", label: "City", crm_field_api_name: "" },
      { key: "state", label: "State", crm_field_api_name: "" },
      { key: "country", label: "Country", crm_field_api_name: "" },
      // {
      //   key: "record_owner",
      //   label: "Record Owner",
      //   crm_field_api_name: "",
      // },
      {
        key: "crm_owner_name",
        label: "Record Owner",
        crm_field_api_name: "crm_owner_name",
      },
    ];
    const companyFields = [
      { key: "domain", label: "Domain", crm_field_api_name: "" },
      {
        key: "headquarters_city",
        label: "City",
        crm_field_api_name: "",
      },
      {
        key: "headquarters_state",
        label: "State",
        crm_field_api_name: "",
      },
      {
        key: "headquarters_country",
        label: "Country",
        crm_field_api_name: "",
      },
      {
        key: "employee_count",
        label: "Employee count",
        crm_field_api_name: "",
      },
      // {
      //   key: "record_owner",
      //   label: "Record Owner",
      //   crm_field_api_name: "",
      // },
      {
        key: "crm_owner_name",
        label: "Record Owner",
        crm_field_api_name: "crm_owner_name",
      },
    ];
    let staticFields = [];
    const mapFields = [];
    if (type === "person") {
      staticFields = personFields;
    } else {
      staticFields = companyFields;
    }
    staticFields.map((el) => {
      if (obj && obj.mappings && obj.mappings.length > 0) {
        let mapobj = {};
        mapobj = obj.mappings.find((map) => map.system_field_name === el?.key);
        mapFields.push({
          system_field_name: el?.key,
          label: mapobj?.crm_field_label ? mapobj?.crm_field_label : el?.label,
          crm_field_api_name: mapobj?.crm_field_api_name
            ? mapobj?.crm_field_api_name
            : el?.crm_field_api_name,
        });
      }
    });

    const transformedArray = mapFields.reduce(
      (acc, item) => {
        // Check for location fields
        const locationKeys =
          type === "person"
            ? ["city", "state", "country"]
            : ["headquarters_city", "headquarters_state", "headquarters_country"];

        if (locationKeys.includes(item.system_field_name)) {
          acc.location = acc.location || {
            system_field_name: "location",
            label: "Location",
            location: {},
          };

          const uniformKey =
            item.system_field_name === "headquarters_city"
              ? "city"
              : item.system_field_name === "headquarters_state"
                ? "state"
                : item.system_field_name === "headquarters_country"
                  ? "country"
                  : item.system_field_name;

          acc.location.location[uniformKey] = item;
        } else {
          acc.fields.push(item);
        }
        return acc;
      },
      { fields: [], location: null }
    );

    const returnArr = [...transformedArray.fields];
    if (transformedArray.location) {
      if (type === "person") {
        returnArr.splice(2, 0, transformedArray.location);
      } else {
        returnArr.splice(1, 0, transformedArray.location);
      }
    }

    // console.log("returnArr", returnArr);
    return returnArr;
  } catch (error) {
    console.error("Error:", error);
    return [];
  }
};

export const truncateValue = (value, maxLength = 60) => {
  if (!value) return "";
  if (value.length > maxLength) {
    return value.slice(0, maxLength) + "...";
  }
  return value;
};

export const isUUIDKey = (key) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(key);
};

export const sendEventToloadBulkProfilePage = () => {
  setTimeout(() => {
    const newevent = new CustomEvent("load_bulk_page", {
      detail: true,
    });
    window.dispatchEvent(newevent);
  }, 500);
};

export const returnRecentPagePath = (params) => {
  if (params && params?.bulkProfilePage) {
    return "/contact-viewer/bulk-profiles";
  } else if (params && params.person_id) {
    return "/contact-viewer/";
  } else if (params && params.infoPage) {
    return "/contact-viewer/how-to-begin";
  } else {
    return "/contact-viewer/";
  }
};

export const filterInstalledIntegrationsByCategory = (sourceArray, targetCategory) => {
  return sourceArray.filter(
    (obj) =>
      obj.integration &&
      Array.isArray(obj.integration.categories) &&
      obj.integration.categories.includes(targetCategory) &&
      obj.is_enabled
  );
};

export const normalizeValueForDisplay = (val) => {
  if (Array.isArray(val)) {
    if (val.length === 0) return "";

    const allPrimitive = val.every((v) => typeof v === "string" || typeof v === "number");
    return allPrimitive ? val.join(",") : "";
  }

  if (val == null) return "";

  if (typeof val === "string" || typeof val === "number") {
    return String(val);
  }

  return "";
};

export const normalizeInitialValues = (obj) => {
  const normalized = {};

  Object.keys(obj).forEach((key) => {
    normalized[key] = normalizeValueForDisplay(obj[key]);
  });

  return normalized;
};

export const removeNullKeys = (obj) => {
  return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== null));
};
